import { render } from "./UsersHome.vue?vue&type=template&id=0637e0bc&scoped=true"
import script from "./UsersHome.vue?vue&type=script&lang=js"
export * from "./UsersHome.vue?vue&type=script&lang=js"

import "./UsersHome.vue?vue&type=style&index=0&id=0637e0bc&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0637e0bc"]])

export default __exports__